import styled from "styled-components";

export const Container = styled.div `
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    text-align: center;

    button{
        height: 50px;
        background-color: #ebc007;
        outline: none;
        border-radius: 6px;
        border: 0;
        cursor: pointer;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        padding: 0 3rem;
        gap: .5rem;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }
    a{

        text-decoration: none !important;
        color: white;
    }
    img{
        width: 200px;
        height: 200px;
    }
`